export interface TestimonialsType {
    name: string;
    reviewType: "negative" | "positive" | "neutral"; // String literal union
    image?: string;
    comment: string;
}

export const testimonialsData: TestimonialsType[] = [
    {
        name: "Adebayo Gabriel",
        reviewType: "positive",
        image: "/images/person-1.webp",
        comment: "Their professionalism, market knowledge, and attention to detail made the entire process seamless. They provided accurate property listings, guided us through every step, and ensured all paperwork was handled efficiently."
    },
    {
        name: "John Onos",
        reviewType: "negative",
        image: "/images/person-2.webp",
        comment: "The service was okay, but communication and follow-through could have been better. The outcome was fine, but it lacked attention to detail."
    },
    {
        name: "Abdulatif Mubarrack",
        reviewType: "neutral",
        image: "/images/person-3.webp",
        comment: "The team’s attention to detail was evident in how they vetted properties, ensuring I only viewed options that met my criteria. They were always available to answer my questions, explain complex processes, and offer valuable insights that made decision-making easier."
    },
    {
        name: "Tunde David ",
        reviewType: "positive",
        image: "/images/person-4.webp",
        comment: "The team’s attention to detail was evident in how they vetted properties, ensuring I only viewed options that met my criteria. They were always available to answer my questions, explain complex processes, and offer valuable insights that made decision-making easier."
    },
    {
        name: "Wasiu Ismail",
        reviewType: "negative",
        image: "/images/person-5.webp",
        comment: "The process had its positives and negatives. While helpful options were provided, the overall experience felt a bit disorganized, and communication could have been better. It was average overall."
    },
    {
        name: "Mubarak Binary",
        reviewType: "neutral",
        image: "/images/person-6.webp",
        comment: "The service was decent and showed good knowledge of the market, but the response time was slower than expected. The transaction was completed, but it could have been more efficient."
    },
    {
        name: "Samson Samuel",
        reviewType: "positive",
        image: "/images/person-7.webp",
        comment: "What stood out the most was their commitment to ensuring a smooth transaction. They handled all paperwork, coordinated with other parties, and kept me informed every step of the way. Even after the deal was completed, they followed up to ensure I was satisfied with my purchase and offered additional support."
    },
    {
        name: "Daniel Malik",
        reviewType: "negative",
        image: "/images/person-8.webp",
        comment: "I had high expectations based on their reputation, but my experience was underwhelming. The agent was unprepared for property showings and seemed unfamiliar with the details. I expected a more professional approach, especially for a service this critical"
    }
];
